import { render, staticRenderFns } from "./WatchTogetherVideoPreview.vue?vue&type=template&id=a603e064&scoped=true&"
import script from "./WatchTogetherVideoPreview.vue?vue&type=script&lang=js&"
export * from "./WatchTogetherVideoPreview.vue?vue&type=script&lang=js&"
import style0 from "./WatchTogetherVideoPreview.vue?vue&type=style&index=0&id=a603e064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a603e064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a603e064')) {
      api.createRecord('a603e064', component.options)
    } else {
      api.reload('a603e064', component.options)
    }
    module.hot.accept("./WatchTogetherVideoPreview.vue?vue&type=template&id=a603e064&scoped=true&", function () {
      api.rerender('a603e064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/watchTogether/modal/WatchTogetherVideoPreview.vue"
export default component.exports